// Auto-generated normalizer for table: Puesto
export function puestoNormalize(row) {
  return {
    idPuesto: row.idPuesto ?? row.IdPuesto ?? row['IdPuesto'] ?? 0,
    idAreaNegocio: row.idAreaNegocio ?? row.IdAreaNegocio ?? row['IdAreaNegocio'] ?? 0,
    clave: row.clave ?? row.Clave ?? row['Clave'] ?? '',
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
